import React from 'react';

import { Form } from 'antd';
import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
`;

const Title = styled.span`
  font-family: var(--font-bold);
  font-size: 12px;
  text-transform: uppercase;
`;

const CheckboxRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
`;

const StyledCheckbox = styled(Checkbox)`
  font-size: 14px;
  span {
    padding-right: 0;
  }
`;

const CompetitorToggleSection = () => {
  return (
    <Container>
      <Title>Competitor Updates</Title>
      <CheckboxRow>
        <Form.Item name="includePriorCompetitors" valuePropName="checked" noStyle>
          <StyledCheckbox className="green">Include data not collected in this update</StyledCheckbox>
        </Form.Item>
      </CheckboxRow>
    </Container>
  );
};

export default CompetitorToggleSection;
